export default __webpack_public_path__ + "static/media/step-13.e2332677.png";